import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative pt-4 px-4 flex-grow" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center gap-2"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " Loading integration... ", -1)
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col gap-3"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-2 items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-8" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "100%",
      viewBox: "0 0 77 77",
      width: "100%",
      xmlns: "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }, [
      /*#__PURE__*/_createElementVNode("pattern", {
        id: "a",
        height: "1",
        patternContentUnits: "objectBoundingBox",
        width: "1"
      }, [
        /*#__PURE__*/_createElementVNode("image", {
          height: "192",
          transform: "scale(.00520833)",
          width: "192",
          "xlink:href": "data:image/png;base64,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"
        })
      ]),
      /*#__PURE__*/_createElementVNode("path", {
        d: "m0 0h77v77h-77z",
        fill: "url(#a)"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-bold" }, "Routable")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Integrate Thatch into Routable", -1)
const _hoisted_7 = { class: "flex flex-col gap-2" }
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold" }, " Send documents to Routable ", -1)
const _hoisted_10 = {
  key: 0,
  class: "bg-green-500 text-xs text-white rounded-md py-0.5 px-4"
}
const _hoisted_11 = {
  key: 1,
  class: "bg-red-400 text-white rounded-md py-0.5 text-xs px-4"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between gap-6" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Send invoices your receive via physical mail, faxes, or email attachments to Routable, easily. ")
], -1)
const _hoisted_13 = { class: "flex flex-col gap-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold" }, " Connect your routable account ")
], -1)
const _hoisted_15 = { class: "max-w-screen-sm w-full" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold" }, " How to get your Routable email ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " In the top right corner, you should see two buttons. select \"My inbox email\". Clicking here will open up a textbox showing your unique email-address created solely for uploading bills to your Routable inbox. "),
  /*#__PURE__*/_createElementVNode("img", {
    class: "mt-4 w-9/12",
    src: "/routable-screenshot.jpg"
  })
], -1)

import {
	UiLoader,
	UiCard,
	UiButton,
	UiInput,
	useForm,
	UiForm
} from '@/ui-kit';
import { useToggle } from '@vueuse/core';
import { useIntegrations } from '../use-intergations';
import { onBeforeMount } from 'vue';
import { env } from '@/config';
import { useRoute, useRouter } from 'vue-router';
import { required, email } from '@vuelidate/validators';


export default /*#__PURE__*/_defineComponent({
  __name: 'Routable',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const {
	routableIntegration,
	isRoutableLoaded,
	attachRoutable,
	deleteRoutable,
	loadRoutable
} = useIntegrations();
const [isConnecting, setIsConnecting] = useToggle();

onBeforeMount(async () => {
	if (!isRoutableLoaded.value) {
		await loadRoutable();

		if (routableIntegration.value) {
			fillFormData(routableIntegration.value);
		}
	}
});

const { formData, onSubmit, fillFormData } = useForm(
	{
		email: ''
	},
	{
		email: {
			required,
			email
		}
	}
);

const attach = onSubmit(async (data) => {
	setIsConnecting(true);
	await attachRoutable(data.email);
	setIsConnecting(false);
});

async function disconnect() {
	setIsConnecting(true);
	await deleteRoutable();
	setIsConnecting(false);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isRoutableLoaded))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_unref(UiLoader))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createVNode(_unref(UiCard), { theme: "white" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  (_unref(routableIntegration))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Enabled "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, " Disabled "))
                ]),
                _hoisted_12
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(UiCard), { theme: "white" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_unref(UiForm), {
                  class: "flex justify-between gap-2 w-full",
                  onSubmit: _unref(attach)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_unref(UiInput), {
                        name: "email",
                        label: "Add your routable email address here",
                        type: "email",
                        placeholder: "yourroutableemail@routable-mail.com",
                        modelValue: _unref(formData).email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).email) = $event)),
                        disabled: 
									_unref(isConnecting) ||
									!!_unref(routableIntegration)
								
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    (!_unref(routableIntegration))
                      ? (_openBlock(), _createBlock(_unref(UiButton), {
                          key: 0,
                          class: "!h-8 mt-9 ml-auto",
                          theme: "primary-outlined",
                          loading: _unref(isConnecting)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Connect ")
                          ]),
                          _: 1
                        }, 8, ["loading"]))
                      : (_openBlock(), _createBlock(_unref(UiButton), {
                          key: 1,
                          onClick: disconnect,
                          class: "!h-8 mt-9 ml-auto",
                          theme: "danger-outlined",
                          loading: _unref(isConnecting)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Disconnect ")
                          ]),
                          _: 1
                        }, 8, ["loading"]))
                  ]),
                  _: 1
                }, 8, ["onSubmit"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(UiCard), { theme: "white" }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ]))
  ]))
}
}

})